import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  hubUrl: (window as { [key: string]: any }).env.hubUrl || 'default',
  apiUrl: (window as { [key: string]: any }).env.apiUrl || 'default',
  authCodeFlowIssuer: (window as { [key: string]: any }).env.authCodeFlowIssuer || 'default',
  systemLogsUrl: (window as { [key: string]: any }).env.systemLogsUrl || 'default',
  fastReportUrl: (window as { [key: string]: any }).env.fastReportUrl || 'default',
  requireHttps: (window as { [key: string]: any }).env.requireHttps || false,
  edubotScript: (window as { [key: string]: any }).env.edubotScript || '',
  externalModulesUrls: {
    careerOffice: (window as { [key: string]: any }).env.externalModulesUrls.careerOffice || 'default',
    dormitories: (window as { [key: string]: any }).env.externalModulesUrls.dormitories || 'default',
    recruitment: (window as { [key: string]: any }).env.externalModulesUrls.recruitment || 'default',
    questionnaires: (window as { [key: string]: any }).env.externalModulesUrls.questionnaires || 'default',
  },
  angularConfiguration: 'testing',
};
